import { Layout } from 'antd';
import { useLocation } from "react-router-dom";
import PageHeader from "../header";
import EmptyHeader from "../emptyheader";
import PageFooter from "../footer";
import './index.less';

const { Header, Footer, Content, } = Layout;
export default function Index(props){
  const { children } = props;
  const location = useLocation();
  const isPrint = location.pathname.includes('print');
  const token = window.localStorage.getItem('token') || true;

  return <Layout>
    {!isPrint && (token ? <Header className="page-layout-header"><PageHeader /></Header> : <EmptyHeader />)}
    <Content className="page-layout-content">{children}</Content>
    {!isPrint && <Footer className="page-layout-footer"><PageFooter /></Footer>}
  </Layout>;
};
